import axios from './axios';
import { API_ENDPOINT_URL } from '@moxie/constants';
import { IResponse } from '@shared-components/models';

const getChecklists = async (): Promise<IResponse> => {
  return axios.get(`${API_ENDPOINT_URL.CHECKLISTS}`);
};

export { getChecklists };
